<template>
    <div>
        <div>
            <div style="display: flex;justify-content: space-between">
                <div>
                    <el-input placeholder="请输入程序模式名进行搜索，可以直接回车搜索..." prefix-icon="el-icon-search"
                              clearable
							  size="medium"
                              @clear="initEmps"
                              style="width: 350px;margin-right: 10px" v-model="keyword"
                              @keydown.enter.native="initEmps" :disabled="showAdvanceSearchView"></el-input>
                    <el-button icon="el-icon-search" type="primary" @click="initEmps" :disabled="showAdvanceSearchView">
                        搜索
                    </el-button>
                </div>
                <div>
                    <el-button type="primary" icon="el-icon-plus" @click="showAddEmpView">
                        添加程序模式
                    </el-button>
                </div>
            </div>
            <transition name="slide-fade">
                <div v-show="showAdvanceSearchView"
                     style="border: 1px solid #409eff;border-radius: 5px;box-sizing: border-box;padding: 5px;margin: 10px 0px;">
                    <el-row style="margin-top: 10px">
                        <el-col :span="6">
							<div class="flex-center advance_seit_box">
								<div class="box_tit">场所联系人：</div>
								<div>
									<el-input placeholder="请输入场所联系人" size="medium" v-model="searchValue.ktiContacts"></el-input>
								</div>
							</div>
                        </el-col>
						<el-col :span="6">
							<div class="flex-center advance_seit_box">
								<div class="box_tit">联系方式：</div>
								<div>
									<el-input placeholder="请输入场所联系人方式" size="medium" v-model="searchValue.ktiContactWay"></el-input>
								</div>
							</div>
						</el-col>
                        <el-col :span="6">
							<div class="flex-center advance_seit_box">
								<div class="box_tit">场所状态：</div>
								<div>
									<el-radio-group v-model="searchValue.ktiIsEnable">
										<el-radio :label="0">启用</el-radio>
										<el-radio :label="1">停用</el-radio>
									</el-radio-group>
								</div>
							</div>
                        </el-col>
                        <el-col :span="6" >
							<div class="txt_align_right advance_btn_warp">
								<el-button size="mini" icon="el-icon-search" type="primary" @click="initEmps('advanced')">搜索</el-button>
							</div>
                        </el-col>
                    </el-row>
                </div>
            </transition>
        </div>
        <div style="margin-top: 10px">
            <el-table
                    :data="emps"
                    stripe
                    border
                    v-loading="loading"
                    element-loading-text="正在加载..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    style="width: 100%">
                <!-- <el-table-column
                        type="selection"
                        width="55">
                </el-table-column> -->
                <el-table-column
                        prop="kqmName"
                        align="center"
                        label="程序模式名称"
                        min-width="10%">
                </el-table-column>                
				<el-table-column
						align="center"
				        prop="kqmId"
				        min-width="40%"
				        label="H5链接地址">
						<template slot-scope="scope">
							<span>
								<a target="_blank" :href="'https://wxjkcn.com/h5/#/index?modelId='+scope.row.kqmId">https://wxjkcn.com/h5/#/index?modelId={{scope.row.kqmId}}</a>
							</span>
						</template>
				</el-table-column>
				<el-table-column
						align="center"
				        prop="kqmId"
				        min-width="10%"
				        label="H5二维码">
						<template slot-scope="scope">
							<span>
								<a href="#" @click="getH5Qrcode(scope.row)">点击查看</a>
								<!-- <a target="_blank" :href="'https://wxjkcn.com/h5/#/index?modelId='+scope.row.kqmId">https://wxjkcn.com/h5/#/index?modelId={{scope.row.kqmId}}</a> -->
							</span>
						</template>
				</el-table-column>
				<el-table-column
						align="center"
				        prop="kqmId"
				        min-width="10%"
				        label="小程序二维码">
						<template slot-scope="scope">
							<span>
								<a href="#" @click="getQrcode(scope.row)">点击查看</a>
							</span>
						</template>
				</el-table-column>
				<el-table-column
						align="center"
				        prop="kqmInvisible"
				        min-width="10%"
				        label="隐形内容开关">
						<template slot-scope="scope">
							<span v-if="scope.row.kqmInvisible == '1'">关</span>
							<span v-else-if="scope.row.kqmInvisible == '0'">开</span>
							<span v-else>-</span>
						</template>
				</el-table-column>
<!-- 				<el-table-column
						align="center"
				        prop="kqmDialecticCount"
				        min-width="10%"
				        label="辨证次数">
				</el-table-column> -->
				<el-table-column
						align="center"
				        prop="kqmCostNumEnable"
				        min-width="10%"
				        label="预充值数开关">
						<template slot-scope="scope">
							<span v-if="scope.row.kqmCostNumEnable == '1'">关</span>
							<span v-else-if="scope.row.kqmCostNumEnable == '0'">开</span>
							<span v-else>-</span>
						</template>
				</el-table-column>
                <el-table-column
						align="center"
						min-width="10%"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button @click="showEditEmpView(scope.row)" style="padding: 3px" size="mini">编辑</el-button>
                        <el-button @click="deleteEmp(scope.row)" style="padding: 3px" size="mini" type="danger">删除</el-button>
						<!-- <el-button @click="getQrcode(scope.row)" style="padding: 3px" size="mini" type="primary">查看二维码</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: flex-end">
                <el-pagination
                        background
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        layout="sizes, prev, pager, next, jumper, ->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog
                :title="title"
                :visible.sync="dialogVisible"
                width="80%">
            <div>
                <el-form :model="emp" :rules="rules" ref="empForm">
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="程序模式名称:" prop="kqmName">
								<div class="input_box">
									<el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.kqmName"
									          placeholder="请输入程序模式名称" maxlength="50" show-word-limit></el-input>
								</div>
                            </el-form-item>
                        </el-col>
						<el-col :span="8">
						    <el-form-item label="辨识:">
								<div class="input_box">
									<el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.kqmNameBianshi"
									          placeholder="" maxlength="20" show-word-limit></el-input>
								</div>
						    </el-form-item>
						</el-col>
						<el-col :span="8">
						    <el-form-item label="描述:">
								<div class="input_box">
									<el-input size="mini" style="width: 170px" prefix-icon="el-icon-edit" v-model="emp.kqmNameRemark"
									          placeholder="" maxlength="20" show-word-limit></el-input>
								</div>
						    </el-form-item>
						</el-col>
                    </el-row>
					<el-row>
						<el-col :span="8">
						    <el-form-item label="方案:">
								<div class="input_box">
									<el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.kqmResName"
									          placeholder="" maxlength="20" show-word-limit></el-input>
								</div>
						    </el-form-item>
						</el-col>
						<el-col :span="8">
						    <el-form-item label="描述:">
								<div class="input_box">
									<el-input size="mini" style="width: 170px" prefix-icon="el-icon-edit" v-model="emp.kqmResRemark"
									          placeholder="" maxlength="20" show-word-limit></el-input>
								</div>
						    </el-form-item>
						</el-col>
					</el-row>
					<el-row v-if="!emp.kqmId">
					    <el-col >
					        <el-form-item label="复制的程序模式:" prop="copyFromQmId">
								<el-select v-model="emp.copyFromQmId" placeholder="选择程序模式" clearable style="margin-right: 10px" >
								    <el-option
								      v-for="item in totalQuestionModels"
								      :key="item.kqmId"
								      :label="item.kqmName"
								      :value="item.kqmId">
								    </el-option>	
								</el-select>
					        </el-form-item>
					    </el-col>
					</el-row>
                    <el-row>
						<el-col >
						    <el-form-item label="程序模式状态:" prop="kqmIsEnable">
						        <el-radio-group v-model="emp.kqmIsEnable">
						            <el-radio :label="0">启用</el-radio>
						            <el-radio :label="1">停用</el-radio>
						        </el-radio-group>
						    </el-form-item>
						</el-col>
                    </el-row>
					<el-row>
						<el-col >
						    <el-form-item label="隐形内容开关:" prop="kqmInvisible">
						        <el-radio-group v-model="emp.kqmInvisible">
						            <el-radio :label="0">开</el-radio>
						            <el-radio :label="1">关</el-radio>
						        </el-radio-group>
						    </el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col >
						    <el-form-item label="适用范围:" prop="kqmCrowd">
						        <el-radio-group v-model="emp.kqmCrowd">
						            <el-radio :label="1">男</el-radio>
						            <el-radio :label="0">女</el-radio>
									<el-radio :label="2">不限</el-radio>
						        </el-radio-group>
						    </el-form-item>
						</el-col>
					</el-row>
<!-- 					<el-row>
						<el-col >
						    <el-form-item label="辨证次数:" prop="kqmDialecticCount">
								<el-select v-model="emp.kqmDialecticCount" placeholder="选择程序辨证次数" clearable style="margin-right: 10px" >
								    <el-option
								      v-for="item in dialecticCount"
								      :key="item"
								      :label="item"
								      :value="item">
								    </el-option>	
								</el-select>
						    </el-form-item>
						</el-col>
					</el-row> -->
					<el-row>
						<el-col >
						    <el-form-item label="预充值数开关:" prop="kqmCostNumEnable">
						        <el-radio-group v-model="emp.kqmCostNumEnable">
						            <el-radio :label="0">开</el-radio>
						            <el-radio :label="1">关</el-radio>
						        </el-radio-group>
						    </el-form-item>
						</el-col>
					</el-row>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="doAddEmp">确 定</el-button>
			  </span>
        </el-dialog>
		<el-dialog :visible.sync="qrcodeDialogVisible" width="50%" @open="showqrCode" ref="qrcodeDialog">
			<div style="display: flex;align-items: center;flex-direction: column;" id="mpQrCode">
				<div class="qrcode" ref="qrCodeUrl" style="width: 200px;"></div>
				<el-button size="medium" type="primary" plain style="width: 200px;margin-top: 20px;" @click="download()">下载二维码</el-button>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="h5QrcodeDialogVisible" width="50%" @open="showH5QrCode" ref="h5QrcodeDialog">
			<div style="display: flex;align-items: center;flex-direction: column;" id="h5QrCode">
				<div class="qrcode" ref="h5QrCodeUrl" style="width: 200px;"></div>
				<el-button size="medium" type="primary" plain style="width: 200px;margin-top: 20px;" @click="downloadH5()">下载二维码</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	//所需页面导入
	import vue from 'vue'
	import QRCode from 'qrcodejs2'
    export default {
        name: "Tenants",
        data() {
            return {
                searchValue: {
					ktiContacts:'',
					ktiContactWay:'',
					ktiIsEnable:''
                },
                title: '',
				showAdvanceSearchView: false,
                allDeps: [],
                emps: [],
				dialecticCount:[
					'1','2','3','4','5','6','7','8','9','10',
					'11','12','13','14','15','16','17','18','19','20'
				],
                loading: false,
                dialogVisible: false,
				qrcodeDialogVisible:false,
				h5QrcodeDialogVisible:false,
                total: 0,
                page: 1,
                keyword: '',
                size: 10,
				tempKqmId:'',
				tempKqmName:'',
				totalQuestionModels:[],
                emp: {
					kqmId:'',
					kqmName:'',
					kqmNameBianshi:'',
					kqmNameRemark:'',
					kqmResName:'',
					kqmResRemark:'',
					copyFromQmId:'',
					kqmIsEnable:'',
					kqmInvisible:'',
					kqmCostNumEnable:'',
					kqmCrowd:'',
					kqmDialecticCount:''
                },
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                rules: {
                    kqmName: [{required: true, message: '请输入程序模式名', trigger: 'blur'}],
					kqmIsEnable: [{required: true, message: '请选择程序模式状态', trigger: 'blur'}],
					kqmInvisible: [{required: true, message: '请选择隐形内容开关', trigger: 'blur'}],
					kqmCostNumEnable: [{required: true, message: '请选择预充值数开关', trigger: 'blur'}],
					kqmCrowd: [{required: true, message: '请选择适用范围', trigger: 'blur'}]
					/* kqmDialecticCount: [{required: true, message: '请选择程序辨证次数', trigger: 'blur'}] */
                }
            }
        },
        mounted() {
            this.initEmps();
            this.initData();
			this.totalModels();
        },
        methods: {
            emptyEmp() {
                this.emp = {
					kqmId:'',
                    kqmName:'',
                    kqmIsEnable:'',
					kqmInvisible:'',
					kqmCostNumEnable:'',
					kqmDialecticCount:'',
					kqmNameBianshi:'',
					kqmNameRemark:'',
					kqmResName:'',
					kqmResRemark:'',
					kqmCrowd:''
                }
            },
            showEditEmpView(data) {
				console.log(data)
				data.kqmIsEnable = parseInt(data.kqmIsEnable)
				data.kqmInvisible = parseInt(data.kqmInvisible)
				data.kqmCostNumEnable = parseInt(data.kqmCostNumEnable)
				data.kqmCrowd = parseInt(data.kqmCrowd)
                this.title = '编辑程序模式信息';
                this.emp = data;
                this.dialogVisible = true;
            },
			getQrcode(data){
				console.log(data.kqmId)
				this.tempKqmId = data.kqmId
				this.tempKqmName = data.kqmName
				this.qrcodeDialogVisible = true
			},
			getH5Qrcode(data){
				console.log(data.kqmId)
				this.tempKqmId = data.kqmId
				this.tempKqmName = data.kqmName
				this.h5QrcodeDialogVisible = true
			},
			showqrCode(){
				vue.nextTick(_ => {
					this.$refs.qrCodeUrl.innerHTML = '';
					var qrcode = new QRCode(this.$refs.qrCodeUrl, {
						text: 'https://wxjkcn.com/weixin/miniprogram/?modelId=' + this.tempKqmId + '&tempKqmName=' + this.tempKqmName, // 需要转换为二维码的内容
						width: 200,
						height: 200,
						colorDark: '#000000',
						colorLight: '#ffffff',
						correctLevel: QRCode.CorrectLevel.H
					})
				})
			},
			showH5QrCode(){
				vue.nextTick(_ => {
					this.$refs.h5QrCodeUrl.innerHTML = '';
					var qrcode = new QRCode(this.$refs.h5QrCodeUrl, {
						text: 'https://wxjkcn.com/h5/#/index?modelId=' + this.tempKqmId, // 需要转换为二维码的内容
						width: 200,
						height: 200,
						colorDark: '#000000',
						colorLight: '#ffffff',
						correctLevel: QRCode.CorrectLevel.H
					})
				})
				
			},
			downloadH5(){
				//获取canvas标签
				let canvas = document.getElementById('h5QrCode').getElementsByTagName('canvas')
				//创建a标签
				let a = document.createElement('a')
				//获取二维码的url并赋值为a.href
				a.href = canvas[0].toDataURL('img/png')
				//设置下载文件的名字
				a.download = '二维码'
				//点击事件，相当于下载
				a.click()
			},
			download() {
				//获取canvas标签
				let canvas = document.getElementById('mpQrCode').getElementsByTagName('canvas')
				//创建a标签
				let a = document.createElement('a')
				//获取二维码的url并赋值为a.href
				a.href = canvas[0].toDataURL('img/png')
				//设置下载文件的名字
				a.download = '二维码'
				//点击事件，相当于下载
				a.click()
			},
            deleteEmp(data) {
                this.$confirm('此操作将永久删除【' + data.kqmName + '】, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteRequest("/questionModel/basic/del/" + data.kqmId).then(resp => {
                        if (resp) {
                            this.initEmps();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            doAddEmp() {
				console.log(this.emp)
                if (this.emp.kqmId) {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/questionModel/basic/update", this.emp).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initEmps();
                                }
                            })
                        }
                    });
                } else {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/questionModel/basic/add", this.emp).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
                                    this.initEmps();
                                }
                            })
                        }
                    });
                }
            },
            initData() {
				
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initEmps();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initEmps('advanced');
            },
            showAddEmpView() {
                this.emptyEmp();
                this.title = '添加程序模式';
                this.dialogVisible = true;
            },
            initEmps(type) {
                this.loading = true;
                let url = '/questionModel/basic/getQuestionModels?page=' + this.page + '&size=' + this.size + '&keyword=' + this.keyword;
                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.emps = resp.data;
                        this.total = resp.total;
                    }
                });
            },
			totalModels(){
				let url = '/question/basic/getQuestionModelsList';
				this.getRequest(url).then(resp => {
				    if (resp) {
				        this.totalQuestionModels = resp.obj;
				    }
				});
			}
        }
    }
</script>

<style scoped lang="scss">
    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .8s ease;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
	/deep/ .el-form-item__label {
		width: 8.125rem !important;
	}
	.el-form-item {
		display: flex;
		.input_box {
			width: 14.5rem;
			.el-input {
				width: 100% !important;
			}
		}
	}
	.advance_seit_box {
		line-height: 2.5rem;
		height: 2.5rem;
		font-size: 0.875rem;
		margin-right: 4rem;
		.box_tit {
			font-size: 0.875rem;
		}
	}
	.advance_btn_warp {
		line-height: 2.5rem;
		height: 2.5rem;
	}
</style>
